import type { RowData } from "@tanstack/react-table";
import { useContext } from "react";

import { DataTableContext, type DataTableContextValue } from "../context";

function useDataTableContext<TData extends RowData, TSortBy = string>() {
  const ctx = useContext(DataTableContext) as DataTableContextValue<
    TData,
    TSortBy
  > | null;
  if (!ctx) {
    throw new Error(
      "useDataTableContext must be used within DataTable.Provider"
    );
  }
  return ctx;
}

export { useDataTableContext };
